<template>
  <v-app class="custom-app" id="inspire">
    <el-container style="height: 500px; background-color: white">
      <Sidebar :isCollapse="isCollapse"></Sidebar>
      
      <el-container direction="vertical" v-loading.fullscreen.lock="auth.isLoading">
        <Header :isCollapse="isCollapse" :toggleMenu="toggleMenu"></Header>
        <el-main class="pa-4 ml-4">
          <Breadcrumbs></Breadcrumbs>
          <router-view></router-view>
        </el-main> 
      </el-container>
    </el-container>
  </v-app>
</template>

<script>
import Header from "./Header";
import Sidebar from "./Sidebar";
import Breadcrumbs from "./Breadcrumbs";
import { mapState, mapActions } from "vuex";
export default {
  components: {
    Header,
    Sidebar,
    Breadcrumbs
  },
  data: () => {
    return {
      drawer: true,
      left: false,
      fullscreenLoading: true,
      isCollapse: false
    };
  },
  props: {
    source: String
  },
  computed: {
    title() {
      return this.$route.meta.title;
    },
    ...mapState({
      alert: state => state.alert,
      auth: state => state.auth
    })
  },
  methods: {
    ...mapActions({
      logout: "auth/logout"
    }),
    updateDrawer(e) {
      this.drawer = e;
    },
    toggleMenu(e) {
      this.isCollapse = e;
    }
  }
};
</script>

<style>
html {
  font-family: "Roboto", sans-serif !important;
}

.bg-primary {
  background-color: #4a90e2;
}
.bg-success {
  background-color: #00b51e;
}
.bg-warning {
  background-color: #fa6000;
}
.bg-danger {
  background-color: #e02020;
}
.el-header {
  background-color: #b3c0d1;
  color: #333;
  line-height: 60px;
}

.el-aside {
  color: #333;
}
.main-layout-header {
  background-image: linear-gradient(#1f36be, #2883d7, #2fc5ed);
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.el-dropdown-menu__item {
}
</style>

